import {
  AreaSelection,
  ChangeLanguage,
  ChangePassword,
  ComplaintsAndSuggestions,
  ComplaintsAndSuggestionsDone,
  ConfigurationDisplay,
  Information,
  NotificationSettings,
  ObjectsLost,
  PaymentMethod,
  Terms,
  Unsubscribe,
  UserInfo
} from '../pages'

export const configurationUrls = {
  configurationDisplay: '/configuration',
  userInfo: '/user-info',
  areaSelection: '/area-selection',
  information: '/information',
  changeLanguage: '/change-language',
  notificationSettings: '/notification-settings',
  changePassword: '/change-password',
  unsubscribe: '/unsubscribe',
  paymentMethod: '/payment-method',
  terms: '/terms',
  complaintsAndSuggestions: '/complaints-and-suggestions',
  objectsLost: '/objects-lost',
  complaintsAndSuggestionsDone: '/complaints-and-suggestions-done'
}

export const configurationRoutes = [
  { content: ConfigurationDisplay, url: configurationUrls.configurationDisplay, isAuthenticated: true },
  { content: UserInfo, url: configurationUrls.userInfo, isAuthenticated: true },
  { content: AreaSelection, url: configurationUrls.areaSelection, isAuthenticated: true },
  { content: Information, url: configurationUrls.information, isAuthenticated: true },
  { content: ChangeLanguage, url:configurationUrls.changeLanguage, isAuthenticated: true },
  { content: NotificationSettings, url: configurationUrls.notificationSettings, isAuthenticated: true },
  { content: ChangePassword, url:configurationUrls.changePassword, isAuthenticated: true },
  { content: Unsubscribe, url: configurationUrls.unsubscribe, isAuthenticated: true },
  { content: PaymentMethod, url: configurationUrls.paymentMethod, isAuthenticated: true },
  { content: Terms, url: configurationUrls.terms, isAuthenticated: true },
  { content: ComplaintsAndSuggestions, url: configurationUrls.complaintsAndSuggestions, isAuthenticated: true },
  { content: ObjectsLost, url: configurationUrls.objectsLost, isAuthenticated: true },
  { content: ComplaintsAndSuggestionsDone, url: configurationUrls.complaintsAndSuggestionsDone, isAuthenticated: true }
]
